// src/components/PedidoRegister.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PedidoRegister.css';

const PedidoRegister = () => {
  const navigate = useNavigate();

  // Navegación interna / externa
  const navigateTo = (dest) => {
    if (dest.startsWith('http://') || dest.startsWith('https://')) {
      window.open(dest, '_blank');
    } else {
      navigate(dest);
    }
  };

  return (
    <div className="pr-container">
      <h2 className="pr-title">¿Qué tipo de pedido quieres crear?</h2>
      <div className="pr-cards">
      <div
  className="pr-card"
  onClick={() => navigateTo('/register-order')}
>
  <span className="pr-icon" role="img" aria-label="Icono de documento">📄</span>
  <h3>Pedido Completo</h3>
  <button
    className="pr-button"
    onClick={(e) => {
      e.stopPropagation();
      navigateTo('/register-order');
    }}
  >
    Ir
  </button>
</div>

<div
  className="pr-card"
  onClick={() => navigateTo('/register-window-order')}
>
  <span className="pr-icon" role="img" aria-label="Icono de caja">📦</span>
  <h3>Pedido Simple</h3>
  <button
    className="pr-button"
    onClick={(e) => {
      e.stopPropagation();
      navigateTo('/register-window-order');
    }}
  >
    Ir
  </button>
</div>

      </div>
    </div>
  );
};

export default PedidoRegister;
